<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.permits.documents.title') }}</h1>
      <i-button
        type="primary"
        size="medium"
        @click="isAddDocumentsDialogOpen = true"
      >
        <icon-plus class="tw-mr-2" />
        {{ $t('adm.permits.documents.documents_dialog.title_new') }}
      </i-button>
    </div>

    <div v-loading="isLoading">
      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/permitManagement/documents"
          list-relative-path="documents"
          list-item-component-name="PermitDocumentListItem"
          list-item-prop-name="document"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/permitManagement/documents"
        filter-relative-path="filters"
      />
    </div>

    <AddPermitDocumentDialog
      :is-open="isAddDocumentsDialogOpen"
      @close="isAddDocumentsDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import { documentsTableColumns } from '@/components/Administration/PermitManagement/Documents/constants';
import AddPermitDocumentDialog from '@/components/Administration/PermitManagement/Documents/AddPermitDocumentDialog.vue';
import { mapState } from 'vuex';

export default {
  name: 'PermitDocumentsV2',
  components: {
    AddPermitDocumentDialog,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddDocumentsDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.permitManagement.documents.filters,
      isLoading: (state) => state.v2.admin.cms.permitManagement.documents.isLoading,
    }),
    columns() {
      return documentsTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/permitManagement/documents/load');
    },
  },
};
</script>
